import { getCopilotChatDrawerState } from "../store/store";

export function isCopilotChatDrawerShown(targetWindow?: Window): boolean {
    return getCopilotChatDrawerState(targetWindow ?? window)?.isShown ?? false;
}
